// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1c-2";
export var blackBorderOnHover = "_1c-7";
export var cell = "_1c-6";
export var cellContainer = "_1c-3";
export var checked = "_1c-8";
export var disabled = "_1c-5";
export var featuredIconCellContainer = "_1c-9";
export var featuredIconTextContainer = "_1c-b";
export var featuredIconWrapper = "_1c-a";
export var noBorder = "_1c-c";
export var orangeSelectedRow = "_3i-3";
export var overflowableText = "_1c-0";
export var overflowableTextContainer = "_1c-1";
export var row = "_1e-0";
export var rowCheckboxCell = "_1c-4";
export var selectableTable = "_3i-2";